module.exports = __webpack_public_path__ + "media/images/flags/qa-159daa7e1d43697cc6c990d5022188cc.svg";